export const SegmentsMmxChannelsMapping = [
    { display: "Direct", dataKey: "Direct" },
    { display: "Organic search", dataKey: "Organic Search" },
    { display: "Paid search", dataKey: "Paid Search" },
    { display: "External Referrals", dataKey: "Referrals" },
    { display: "Display Ads", dataKey: "Display Ads" },
    { display: "Social", dataKey: "Social" },
    { display: "Email", dataKey: "Email" },
    {
        display: "Internal Referrals",
        dataKey: "Internal Referrals",
        tooltip: "segments.analysis.mmx.single.chart.label.tooltip.internalReferrals",
    },
];
